import App from './App/App';
import './index.css';

App.go();




/** WEBPACK FOOTER **
 ** ./src/index.js
 **/